// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { PatientType } from "../types";
import { getPatients } from "../api";

export const usePatientsData = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<PatientType>>({
    queryKey: ["patients", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getPatients(token, clinicId, controller.signal);
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the patients page
  });
};
